import React from "react";
import "./ContactInfo.css";
import Cardimg1 from "../../../../assets/images/contactinfocard1.png";
import Cardimg2 from "../../../../assets/images/contactinfocard2.png";
import Cardimg3 from "../../../../assets/images/contactinfocard3.png";
import Card1 from "../../../../Components/Cards/Card1";
const ContactInfo = () => {
  return (
    <div className="contact__info_wrap">
      <div className="contact__info_heading">Contact Info</div>
      <div className="contact__info_cards">
        <div className="contact__info_card">
          <Card1
            containerStyle={{ minHeight: "350px" }}
            image={Cardimg1}
            heading="Office Address"
            backgroundColor="rgba(0, 142, 255, 0.15)"
            dotColor="transparent"
            description="42707 Wardlaw Ter Ashburn Virgina 20147,USA."
          />
        </div>
        <div className="contact__info_card">
          <Card1
            containerStyle={{ minHeight: "350px" }}
            image={Cardimg2}
            heading="Telephone"
            backgroundColor="rgba(20, 176, 130, 0.15)"
            dotColor="transparent"
            description={
              <div className="contactinfo__card_numbers">
                <div>+ 262-735-8874</div> <div>+ 262-735-8874</div>
              </div>
            }
          />
        </div>
        <div className="contact__info_card">
          <Card1
            containerStyle={{ minHeight: "350px" }}
            image={Cardimg3}
            heading="Mail Us"
            backgroundColor="rgba(122, 67, 238, 0.1)"
            dotColor="transparent"
            description={
              <div className="contactinfo__card_numbers">
                <div>contact@serenetax.com</div> <div>info@serenetax.com</div>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
